import axiosFetch from './config';

export const getShortcuts = async(shortcutType)=>{

    let token = await localStorage.getItem('token');
    //console.log(token)
    return await axiosFetch({
      method:'GET',
      url: `/shortcut?shortcutType=${shortcutType}`,
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}

export const deleteShortcut = async(id,accountNumber)=>{
  let token = await localStorage.getItem('token');
  //console.log(`/shortcut/products/${id}`)
  try {
    let resp = axiosFetch({
      method:'DELETE',
      url: `/shortcut/products/${id}?accountNumber=${accountNumber}`, 
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
    return resp
  } catch (error) {
    return error
  }


}
